module.exports = __webpack_public_path__ + "img/slide9.b053fce0.png";